import { gql } from '@apollo/client'
import client from '../utils/client'
import { MutationHandlerError } from '../utils/errors'

type SetRestaurantRelevanceScoreResult =
	| { success: true; errors: null }
	| { success: false; errors: MutationHandlerError }

const setRestaurantRelevanceScore = async ({
	slug,
	relevanceScore,
}: {
	slug: string
	relevanceScore: number | null
}): Promise<SetRestaurantRelevanceScoreResult> => {
	try {
		const { data, errors } = await client.mutate({
			mutation: gql`
				mutation SetRestaurantRelevanceScore($slug: String!, $relevanceScore: Int) {
					setRestaurantRelevanceScore(slug: $slug, relevanceScore: $relevanceScore) {
						success
						error
						# Apollo übernimmt den Score per id in jede Anbieterliste.
						providers {
							id
							relevanceScore
						}
					}
				}
			`,
			variables: { slug, relevanceScore },
			errorPolicy: 'all',
		})

		if (errors) return { success: false, errors }
		const result = data?.setRestaurantRelevanceScore
		if (!result?.success) {
			return { success: false, errors: result?.error || 'Speichern fehlgeschlagen' }
		}
		return { success: true, errors: null }
	} catch (e) {
		if (e && e.networkError) return { success: false, errors: 'NETWORK_ERROR' }
		throw e
	}
}

export default setRestaurantRelevanceScore
